module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_BlackMatted_MockedUp.c61363f9.jpg";